import React from 'react'
import { Link } from "react-router-dom";
import SliderOurCertificate from '../../component/slidercomponent/SliderOurCertificate';


const OurCertificate = () => {
    return (
        <>
            <section className="blog pt_120 xs_pt_100" style={{ marginTop: "-70px" }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8 col-xl-8 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="section_heading left_heading mb_20">
                                <h5>Certificate</h5>
                                <h2 style={{fontSize:"26px"}}>Our Professional Certifications</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <SliderOurCertificate />
                    </div>
                    <br />
                </div>
            </section>
        </>
    )
}

export default OurCertificate
